export default __webpack_public_path__ + "static/media/draft.94d06a07.png";